import React from 'react';
import { Grid } from '@mui/material';
import VideoPlayer from './VideoPlayer';
import InstructionTitle from './InstructionTitle';

/**
 * 4 格视频组件（Slide 3）
 * 使用统一 VideoPlayer，去掉 Video 1/2/3/4 文字
 */
function PhonicsWordVideos({ videos, mediaBase }) {
  return (
    <div style={{ width: '100%' }}>
      <InstructionTitle
        title="Step 2: Repeat the words"
        titleCn="跟着说"
        instructionAudio={`${mediaBase}/audio_instruction_repeat.mp3`}
        inlineCn
      />
      <Grid container spacing={2}>
        {videos.map((video) => (
          <Grid item xs={12} sm={6} key={video.id}>
            <VideoPlayer src={video.src} poster={video.cover} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default PhonicsWordVideos;
